import React from "react";
import { useTranslation, Trans } from "react-i18next";
import styles from "./SendEmailToResetPassword.module.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { MdOutlineMail } from "react-icons/md";
import useModal from "../../../hooks/useModal";
import Modal from "../../UiComponents/modals/Modal";

const SendEmailToResetPassword = ({ email, userLogin }) => {
  const { isShowing, toggle } = useModal();
  const { t } = useTranslation();

  axios.defaults.withCredentials = true;

  const submitFormsForgotPassword = async (email) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/sendEmailForNewPass`,
        { userMail: email }
      );

      if (response.status === 200) {
        toast.success(
          t("superadmin_ui.send_success")
        );
        toggle();
      } else {
        toast.error(t("superadmin_ui.send_error"));
      }
    } catch (error) {
      console.error("Erreur envoi email reset :", error);
      toast.error(t("superadmin_ui.send_error"));
    }
  };

  return (
    <div className={styles.emailAction}>
      <MdOutlineMail
        className={styles.emailIcon}
        onClick={toggle}
        title={t("superadmin_ui.send_reset_email")}
      />
      <Modal isShowing={isShowing} hide={toggle} title={t("superadmin_ui.reset_password_title")}>
        <div className={styles.content}>
          <p className={styles.text}>
            <Trans i18nKey="superadmin_ui.reset_password_text" values={{ email: userLogin }} components={{ strong: <strong /> }} />
          </p>
          <p className={styles.email}>
            {email}
          </p>
          <div className={styles.actions}>
            <button type="button" className={styles.btnCancel} onClick={toggle}>
              {t("common.cancel")}
            </button>
            <button
              type="button"
              className={styles.btnConfirm}
              onClick={() => submitFormsForgotPassword(email)}
            >
              {t("common.send_button")}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SendEmailToResetPassword;
